import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import * as actions from "./Actions";
import * as api from "./Api";
import Types from "./Types";

function* getAllSubjects({ payload }) {
  try {
    yield put(actions.publicLoading(true));
    const result = yield call(api.getAllSubjects);
    yield put(actions.getAllSubjectsSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    yield put(actions.getAllSubjectsFail());
  } finally {
    yield put(actions.publicLoading(false));
  }
}

function* getAllTeachers({ payload }) {
  try {
    yield put(actions.publicLoading(true));
    const result = yield call(api.getAllTeachers);
    yield put(actions.getAllTeachersSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    yield put(actions.getAllTeachersFail());
  } finally {
    yield put(actions.publicLoading(false));
  }
}
function* getTeacher({ payload }) {
  try {
    yield put(actions.publicLoading(true));
    const result = yield call(api.getTeacher, payload);
    yield put(actions.getTeacherSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    yield put(actions.getTeacherFail());
  } finally {
    yield put(actions.publicLoading(false));
  }
}

function* getTeacherCourses({ payload }) {
  try {
    yield put(actions.publicLoading(true));
    const { id, userId } = payload;
    const result = yield call(api.getTeacherCourses, id, userId);
    yield put(actions.getTeacherCoursesSuccess(result.data));
  } catch (error) {
    toast.error(error);
    yield put(actions.getTeacherCoursesFail());
  } finally {
    yield put(actions.publicLoading(false));
  }
}

//Edit Tables

export default function* PublicSaga() {
  yield takeLatest(Types.GET_PUBLIC_SUBJECTS_REQUEST, getAllSubjects);
  yield takeLatest(Types.GET_PUBLIC_TEACHERS_REQUEST, getAllTeachers);
  yield takeLatest(Types.GET_PUBLIC_TEACHER_REQUEST, getTeacher);
  yield takeLatest(Types.GET_PUBLIC_TEACHER_COURSES_REQUEST, getTeacherCourses);
}
